<template>
    <div class="zw-toolbar-wraper"  v-show="isShow">
        <template v-for="btnItem in btnData">
            <el-tooltip class="item" effect="dark" :content="btnItem.name" placement="bottom" :key="btnItem.id">
                <div class="zw-toolbar-btn" v-on:click="onBtnClick(btnItem.click)" v-if="btnItem.icon != null" :key="btnItem.id">
                    <i :class="btnItem.icon"></i>
                </div>
                <div class="zw-toolbar-btn" v-on:click="onBtnClick(btnItem.click)" v-else  :key="btnItem.id">
                    {{btnItem.name}}
                </div>
            </el-tooltip>
        </template>
    </div>
</template>

<script>
    export default {
        name: "zw-toolbar",
        props:{
            isShow:{
                default:false,
                type:Boolean
            },
            btnData:{
                default:[
                    {
                        id:1,
                        name:'编辑',
                        icon:'zw-icon-bianji',
                        click:null
                    }
                ]
            }
        },
        methods:{
            onBtnClick:function (zto) {
                const self=this;
                self.$emit('zw-toolbar-onclick',zto);
            }
        }
    }
</script>

<style scoped>
    @import '../assets/zw-icon/zw-iconfont.css';
    .zw-toolbar-wraper{
        width:100%;
        height: 2.5rem;
        line-height: 2.5rem;
        position: absolute;
        z-index: 100;
        margin-top: .625rem;
        top: 1.5rem;
        text-align: right;
        right: 1rem;
    }
    .zw-toolbar-btn{
        width:2rem;
        height:2rem;
        line-height:2rem;
        text-align: center;
        display: inline-block;
        border: .0625rem solid #0089ff;
        border-radius: 50%;
        background-color: #0089ff;
        color:#FFF;
        cursor: pointer;
        margin: 0 0.125rem 0 0;
    }
    .zw-toolbar-btn:hover{
        color:#FFF;
    }
</style>


// WEBPACK FOOTER //
// src/lib/zw-toolbar.vue